import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import PhoneNumberInput from 'ui-addon-i18n/components/PhoneNumberInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import Loading from '../components/Loading';
import I18n from 'I18n';
import { useEffect, useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import getPrivacyPolicyLink from '../utils/getPrivacyPolicyLink';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const PhoneNumberEditor = ({
  failed,
  loading,
  stagedPhoneNumber,
  onStagedPhoneNumberChange,
  readOnly
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(failed ? I18n.text('userPreferences.errors.phoneNumber.failedToLoadPhoneNumber') : undefined);
  useEffect(() => {
    if (stagedPhoneNumber) {
      if (stagedPhoneNumber.length > 40) {
        setHasError(true);
        setErrorMessage(I18n.text('userPreferences.errors.phoneNumber.phoneNumberTooLong'));
      } else if (stagedPhoneNumber.length < 7) {
        setHasError(true);
        setErrorMessage(I18n.text('userPreferences.errors.phoneNumber.phoneNumberTooShort'));
      } else {
        setHasError(false);
        setErrorMessage(undefined);
      }
    }
  }, [stagedPhoneNumber]);
  if (loading) {
    return /*#__PURE__*/_jsx(Loading, {});
  }
  const error = failed || hasError;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FormControl, {
      "aria-label": "phone-editor",
      label: I18n.text('userPreferences.labels.phoneNumber'),
      help: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link
        },
        options: {
          href: getPrivacyPolicyLink(),
          external: true
        },
        message: "userPreferences.phoneNumber.description_jsx"
      }),
      error: error,
      validationMessage: errorMessage,
      paddingBlockStart: "0",
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(PhoneNumberInput, {
        id: "code",
        "data-test-id": "phone-number",
        value: stagedPhoneNumber || '',
        phoneInputProps: {
          error,
          disabled: failed,
          readOnly
        },
        countrySelectProps: {
          error,
          disabled: failed,
          readOnly
        },
        onChange: onStagedPhoneNumberChange
      })
    })
  });
};
PhoneNumberEditor.propTypes = {
  failed: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  stagedPhoneNumber: PropTypes.string,
  onStagedPhoneNumberChange: PropTypes.func.isRequired
};
export default PhoneNumberEditor;